import { toBigIntOr, toNumberOr } from './units';

export const parseUserData = (result: any): { resetAt: bigint; attempts: number } => {
  if (!result) return { resetAt: 0n, attempts: 0 };
  if (Array.isArray(result) && result.length >= 2) {
    const inner = (result as any)[1];
    const resetAt = toBigIntOr(inner?.resetAt ?? inner?.[0] ?? 0n);
    const attempts = toNumberOr(inner?.attempts ?? inner?.[1] ?? 0);
    return { resetAt, attempts };
  }
  const inner = (result as any)[1] ?? result;
  const resetAt = toBigIntOr(inner?.resetAt ?? inner?.[0] ?? 0n);
  const attempts = toNumberOr(inner?.attempts ?? inner?.[1] ?? 0);
  return { resetAt, attempts };
};
